<nav class="bottom-nav" aria-label="Bottom navigation">
  @for (item of visibleNavItems; track item.labelKey) {
    @if (item.type === 'messages') {
      <a
        href="#"
        class="bottom-nav__item"
        [class.bottom-nav__item--active]="isNavItemActive(item)"
        (click)="onMessagesClick($event)"
        [attr.aria-label]="(areNewMessages ? item.ariaLabelKeyNew : item.ariaLabelKey) | translate">
        <img
          [ngSrc]="areNewMessages && item.iconAlt ? item.iconAlt : item.icon"
          [alt]="item.labelKey | translate"
          width="24"
          height="24"
          class="bottom-nav__icon" />
        <span class="bottom-nav__label">{{ item.labelKey | translate | uppercase }}</span>
      </a>
    } @else {
      <a
        [routerLink]="getNavItemRouterLink(item)"
        [class.bottom-nav__item--active]="item.routerLink ? null : isNavItemActive(item)"
        [routerLinkActive]="item.routerLink ? 'bottom-nav__item--active' : null"
        [routerLinkActiveOptions]="item.routerLink ? { exact: item.routerLinkExact ?? false } : null"
        class="bottom-nav__item"
        [attr.aria-label]="item.ariaLabelKey | translate">
        <img
          [ngSrc]="item.icon"
          [alt]="item.labelKey | translate"
          width="24"
          height="24"
          class="bottom-nav__icon" />
        <span class="bottom-nav__label">{{ item.labelKey | translate | uppercase }}</span>
      </a>
    }
  }
</nav>
